module.exports = __webpack_public_path__ + "img/wala.1c9bf576.svg";